import { createSlice } from "@reduxjs/toolkit";
import {
    CreateOrEditIBCthunk,
    FetchEligibleSemenCollectionCertificatesthunk
} from "./internationalBreedingCertificateAction";

const initialState = {
    isLoading: false,
    eligibleCertificatesData: [],
    createOrEditIBCData: null,
    toasterMessage: null,
    error: null,
};

const internationalBreedingCertificateSlice = createSlice({
    name: "internationalBreedingCertificate",
    initialState,
    reducers: {
        resetToasterMessage: (state) => {
            state.toasterMessage = null;
        },
        resetEligibleCertificatesData: (state) => {
            state.eligibleCertificatesData = [];
        },
        resetCreateOrEditIBCData: (state) => {
            state.createOrEditIBCData = null;
        }
    },
    extraReducers: (builder) => {
        // CreateOrEdit
        builder.addCase(CreateOrEditIBCthunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(CreateOrEditIBCthunk.fulfilled, (state, action) => {
            state.isLoading = false;
            if (action.payload?.status?.responseCode === "100") {
                state.toasterMessage = action.payload.status.detailedResponseCode || "error";
            } else {
                state.toasterMessage = "save";
                state.createOrEditIBCData = action.payload?.result || action.payload?.data || action.payload;
            }
        });
        builder.addCase(CreateOrEditIBCthunk.rejected, (state, action) => {
            state.isLoading = false;
            state.toasterMessage = action.payload || "error";
        });

        // GetEligibleSemenCollectionCertificates
        builder.addCase(FetchEligibleSemenCollectionCertificatesthunk.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(FetchEligibleSemenCollectionCertificatesthunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.eligibleCertificatesData = action.payload || [];
        });
        builder.addCase(FetchEligibleSemenCollectionCertificatesthunk.rejected, (state, action) => {
            state.isLoading = false;
            state.eligibleCertificatesData = [];
            state.error = action.payload;
        });
    },
});

export const { resetToasterMessage, resetEligibleCertificatesData, resetCreateOrEditIBCData } = internationalBreedingCertificateSlice.actions;
export default internationalBreedingCertificateSlice.reducer;
